export default __webpack_public_path__ + "/dist/images/italian-contentimg-2.6a89b086c177a37e0f5fa9165011c0dc.png";